/* eslint-env browser */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AutoSuggestComponent from '@aarhus-university/au-lib-react-components/src/components/AutoSuggestComponent';
import { sortAlphaObj } from '@aarhus-university/au-lib-react-components/src/lib/helpers';
import { langContext } from '../helpers/hooks';
import { labels } from '../i18n';

const getSuggestions = (value, collection, callback) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  const result = inputLength < 2 ? []
    : collection.filter((x) => x.Name.toLowerCase().indexOf(inputValue) > -1)
      .sort(sortAlphaObj);
  callback(result);
};

const AUBachelorSearch = ({ items, centered }) => {
  const lang = useContext(langContext);
  return (
    <div className={`bachelor__education__search${centered ? ' bachelor__education__search--centered' : ''}`}>
      <AutoSuggestComponent
        placeholder={labels.searchHeader[lang]}
        setQuery={() => { }}
        setResults={(results) => {
          if (results.length === 1 && results[0].Uri) {
            window.location.href = results[0].Uri;
          }
        }}
        collection={items}
        getSuggestions={getSuggestions}
        getSuggestionValue={(suggestion) => suggestion.Name}
        renderSuggestion={(suggestion) => <div className="bachelor__education__search__item">{suggestion.Name}</div>}
      />
    </div>
  );
};

AUBachelorSearch.defaultProps = {
  centered: false,
};

AUBachelorSearch.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  centered: PropTypes.bool,
};

AUBachelorSearch.displayName = 'AUBachelorSearch';
export default AUBachelorSearch;
